export const errorMessages = {
  diferentPasswords: `Passwords don't match`,
  emailAlreadyExists: 'The email already exists',
  emailOrPassWrong: 'The email or password are wrong',
  general: 'An error occurred',
  linkedinAuthentication: 'An error occurred when authenticating with Linkedin'
}



// WEBPACK FOOTER //
// ./src/Utils/ErrorMessages.js